import { TPlayResultTypes } from '@/constants';

export const turnoverResults = [
  TPlayResultTypes.INTERCEPTION,
  TPlayResultTypes.FUMBLE_LOST,
  TPlayResultTypes.TOV,
  TPlayResultTypes.PASS_COMP_FUMBLE_LOST,
  TPlayResultTypes.PASS_COMP_FUMBLE_LOST_TD,
  TPlayResultTypes.SACK_FUMBLE_LOST,
  TPlayResultTypes.SACK_FUMBLE_LOST_TD,
  TPlayResultTypes.INTERCEPTION_TD,
  TPlayResultTypes.FUMBLE_LOST_TD,
  TPlayResultTypes.RUSH_ATTEMPT_FUMBLE_LOST,
  TPlayResultTypes.RUSH_ATTEMPT_FUMBLE_LOST_TD,
];

export const fumbleLostResults = [
  TPlayResultTypes.FUMBLE_LOST,
  TPlayResultTypes.PASS_COMP_FUMBLE_LOST,
  TPlayResultTypes.PASS_COMP_FUMBLE_LOST_TD,
  TPlayResultTypes.SACK_FUMBLE_LOST,
  TPlayResultTypes.SACK_FUMBLE_LOST_TD,
  TPlayResultTypes.FUMBLE_LOST_TD,
  TPlayResultTypes.RUSH_ATTEMPT_FUMBLE_LOST,
  TPlayResultTypes.RUSH_ATTEMPT_FUMBLE_LOST_TD,
];

export const interceptionResults = [TPlayResultTypes.INTERCEPTION, TPlayResultTypes.INTERCEPTION_TD];

export const touchdownResults = [
  TPlayResultTypes.TD,
  TPlayResultTypes.PASS_COMP_TD,
  TPlayResultTypes.PASS_COMP_FUMBLE_LOST_TD,
  TPlayResultTypes.SACK_FUMBLE_LOST_TD,
  TPlayResultTypes.INTERCEPTION_TD,
  TPlayResultTypes.FUMBLE_LOST_TD,
  TPlayResultTypes.RUSH_ATTEMPT_TD,
  TPlayResultTypes.RUSH_ATTEMPT_FUMBLE_LOST_TD,
];

export const offensiveTouchdownResults = [
  TPlayResultTypes.TD,
  TPlayResultTypes.PASS_COMP_TD,
  TPlayResultTypes.RUSH_ATTEMPT_TD,
];

export const isMultiTovPlay = (results: TPlayResultTypes[]): boolean =>
  !!results && results.filter((res) => turnoverResults.includes(res)).length > 1;

export const containsInterceptionResult = (results: TPlayResultTypes[]): boolean =>
  results.some((id: number) => interceptionResults.includes(id));

export const containsOffensiveTouchdownResult = (results: TPlayResultTypes[]): boolean =>
  results.some((id: number) => offensiveTouchdownResults.includes(id) && !interceptionResults.includes(id));

export const isCompletePass = (results: TPlayResultTypes[]): boolean =>
  results.every((id: number) => !interceptionResults.includes(id) && id !== TPlayResultTypes.PASS_INCOMP);
